import { Component, OnInit, HostBinding, EventEmitter, Output, Input, forwardRef, Inject } from '@angular/core';
import { ConfigService } from '@argalis-apps/angular-global';
import { AuthConfigService } from '../../services/auth-config/auth-config.service';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { AuthService } from '../../services/auth/auth.service';
import { Router } from '@angular/router';

@Component({
  selector: 'ags-renew-password',
  templateUrl: './renew-password.component.html',
  styleUrls: ['./renew-password.component.scss']
})
export class RenewPasswordComponent implements OnInit {
  @HostBinding('class') themeFlag: string;
  @Input() popupMode: boolean;
  @Output() popupLeave = new EventEmitter();

  public serverError: number = void 0;
  public submitted: boolean = void 0;
  public renewForm: UntypedFormGroup;
  public invalidLogin: boolean = void 0;
  public falsepopup = false;
  public error = false;
  public updatePassword = true;

  constructor(
    private config: ConfigService,
    @Inject(forwardRef(() => AuthService)) private authService: AuthService,
    private authConfig: AuthConfigService,
    private formBuilder: UntypedFormBuilder,
    private router: Router
  ) {
    this.themeFlag = `${this.themeFlag || ''} ${this.authConfig.themingClassName}`;
    this.renewForm = this.formBuilder.group({
      login: new UntypedFormControl(null, [Validators.required, Validators.email])
    });
  }

  ngOnInit() {}

  renew() {
    this.invalidLogin = this.renewForm.get('login').invalid;
    const email: string = this.renewForm.get('login').value;

    if (this.renewForm.valid) {
      this.serverError = void 0;
      this.submitted = true;
      this.authService.renewPassword(email).subscribe(
        result => {
          if (result) {
            this.serverError = void 0;
            this.submitted = false;
            this.renewForm.reset();
            //
            this.popupMode = true;
            this.error = false;
            this.updatePassword = false;
          }
        },
        err => {
          if (err.status) this.serverError = err.status;
          this.submitted = false;
          console.log('NOPE :', err);
          this.falsepopup = true;
          this.error = true;
          this.updatePassword = false;
        }
      );
    }
  }

  closePopup() {
    this.popupLeave.emit();
    this.router.navigate(['/']);
  }
}
